import { ToastProps } from '@chakra-ui/react';
import { useToast } from '@morressier/alembic';

// Use this hook to show a toast for devs
// This is to capture their attention that something must be addressed
// While not crashing the application or showing on prod
export const useDevToast = () => {
  const toast = useToast();

  const devToast = ({
    title,
    description
  }: Pick<ToastProps, 'title' | 'description'>) => {
    if (process.env.NODE_ENV === 'production') {
      return;
    }

    toast({
      title,
      description,
      variant: 'error',
      isClosable: false,
      // 1 hour
      duration: 60 * 1000 * 60
    });
  };
  return devToast;
};
